import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Lightbulb, CheckCircle2, ArrowLeft } from "lucide-react";

const sdgDetails = [
  {
    id: 1,
    title: "No Poverty",
    description: "End poverty in all its forms everywhere.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_01NoPoverty.svg.png",
    color: "#E5243B",
    facts: ["This SDG is the first", "xxxxxx", "xxxxxx"],
    actions: ["xxxxxx", "xxxxxx", "xxxxxx"]
  },
  {
    id: 2,
    title: "Zero Hunger",
    description: "End hunger, achieve food security and improved nutrition.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_02ZeroHunger.svg.png",
    color: "#DDA63A",
    facts: [],
    actions: []
  },
  {
    id: 3,
    title: "Good Health and Well-being",
    description: "Ensure healthy lives and promote well-being for all at all ages.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_03GoodHealth.svg.png",
    color: "#4C9F38",
    facts: [],
    actions: []
  },
  {
    id: 4,
    title: "Quality Education",
    description: "Ensure inclusive and equitable quality education and promote lifelong learning.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_04QualityEducation.svg.png",
    color: "#C5192D",
    facts: [],
    actions: []
  },
  {
    id: 5,
    title: "Gender Equality",
    description: "Achieve gender equality and empower all women and girls.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_05GenderEquality.svg.png",
    color: "#FF3A21",
    facts: [],
    actions: []
  },
  {
    id: 6,
    title: "Clean Water and Sanitation",
    description: "Ensure availability and sustainable management of water and sanitation for all.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_06CleanWaterSanitation.svg.png",
    color: "#26BDE2",
    facts: [],
    actions: []
  },
  {
    id: 7,
    title: "Affordable and Clean Energy",
    description: "Ensure access to affordable, reliable, sustainable, and modern energy.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_07CleanEnergy.svg.png",
    color: "#FCC30B",
    facts: [],
    actions: []
  },
  {
    id: 8,
    title: "Decent Work and Economic Growth",
    description: "Promote sustained, inclusive and sustainable economic growth, full and productive employment, and decent work.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_08DecentWork.svg.png",
    color: "#A21942",
    facts: [],
    actions: []
  },
  {
    id: 9,
    title: "Industry, Innovation and Infrastructure",
    description: "Build resilient infrastructure, promote inclusive and sustainable industrialization, and foster innovation.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_09Industry.svg.png",
    color: "#FD6925",
    facts: [],
    actions: []
  },
  {
    id: 10,
    title: "Reduced Inequalities",
    description: "Reduce inequality within and among countries.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_10ReducedInequalities.svg.png",
    color: "#DD1367",
    facts: [],
    actions: []
  },
  {
    id: 11,
    title: "Sustainable Cities and Communities",
    description: "Make cities and human settlements inclusive, safe, resilient, and sustainable.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_11SustainableCities.svg.png",
    color: "#FD9D24",
    facts: [],
    actions: []
  },
  {
    id: 12,
    title: "Responsible Consumption and Production",
    description: "Ensure sustainable consumption and production patterns.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_12ResponsibleConsumption.svg.png",
    color: "#BF8B2E",
    facts: [],
    actions: []
  },
  {
    id: 13,
    title: "Climate Action",
    description: "Take urgent action to combat climate change and its impacts.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_13Climate.svg.png",
    color: "#3F7E44",
    facts: [],
    actions: []
  },
  {
    id: 14,
    title: "Life Below Water",
    description: "Conserve and sustainably use the oceans, seas and marine resources.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_14LifeBelowWater.svg.png",
    color: "#0A97D9",
    facts: [],
    actions: []
  },
  {
    id: 15,
    title: "Life on Land",
    description: "Protect, restore, and promote sustainable use of terrestrial ecosystems.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_15LifeOnLand.svg.png",
    color: "#56C02B",
    facts: [],
    actions: []
  },
  {
    id: 16,
    title: "Peace, Justice and Strong Institutions",
    description: "Promote peaceful and inclusive societies, provide access to justice, and build effective institutions.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_16PeaceJusticeInstitutions.svg.png",
    color: "#00689D",
    facts: [],
    actions: []
  },
  {
    id: 17,
    title: "Partnerships for the Goals",
    description: "Strengthen the means of implementation and revitalize the global partnership for sustainable development.",
    imageUrl: "https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/public-sdgs/Sustainable_Development_Goal_17Partnerships.svg.png",
    color: "#19486A",
    facts: [],
    actions: []
  }
];

export default function SDGDetail() {
  const { id } = useParams();
  const sdg = sdgDetails.find((s) => s.id === parseInt(id));

  // Navbar Retraction Trigger
  useEffect(() => {
    const navElement = document.querySelector("nav");
    if (navElement) {
      navElement.style.display = "none";
    }
    return () => {
      if (navElement) navElement.style.display = "flex";
    };
  }, []);

  if (!sdg) {
    return (
      <div style={{ minHeight: "100vh", backgroundColor: "#246e31ff", color: "white", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <h2>SDG not found</h2>
        <Link to="/sdgs" style={{ color: "#fff", marginTop: "1rem" }}>Back to SDGs</Link>
      </div>
    );
  }

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#FFFFFF",
      padding: "1.5rem",
      paddingBottom: "4rem",
      fontFamily: "'Inter', sans-serif",
      color: "#2D302D"
    },
    header: {
      display: "flex",
      alignItems: "center",
      marginBottom: "2rem"
    },
    backLink: {
      textDecoration: "none",
      color: "#6B7280",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      fontWeight: "600",
      fontSize: "0.9rem"
    },
    heroSection: {
      textAlign: "center",
      marginBottom: "2.5rem"
    },
    image: {
      width: "120px",
      height: "120px",
      marginBottom: "1rem",
      borderRadius: "16px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.1)"
    },
    title: {
      fontSize: "1.8rem",
      fontWeight: "900",
      color: sdg.color,
      margin: "0.5rem 0"
    },
    description: {
      fontSize: "1rem",
      color: "#4A5568",
      lineHeight: "1.5",
      maxWidth: "500px",
      margin: "0 auto"
    },
    sectionTitle: {
      fontSize: "1.2rem",
      fontWeight: "800",
      color: sdg.color, // Color of the specific SDG
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginTop: "2rem",
      marginBottom: "1rem"
    },
    card: {
      backgroundColor: "#F7F9F7",
      padding: "1rem",
      borderRadius: "16px",
      marginBottom: "0.8rem",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      border: `1px solid ${sdg.color}15` // Subtle border using SDG color
    },
    cardText: {
      fontSize: "0.95rem",
      margin: 0,
      lineHeight: "1.4",
      color: "#2D302D"
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <Link to="/sdgs" style={styles.backLink}>
          <ArrowLeft size={18} /> Back
        </Link>
      </div>

      <div style={styles.heroSection}>
        <img src={sdg.imageUrl} alt={sdg.title} style={styles.image} />
        <h1 style={styles.title}>{sdg.title}</h1>
        <p style={styles.description}>{sdg.description}</p>
      </div>

      <div style={{ maxWidth: "600px", margin: "0 auto" }}>
        {/* FACTS SECTION */}
        <h2 style={styles.sectionTitle}>
          <Lightbulb size={22} /> Key Facts
        </h2>
        {sdg.facts && sdg.facts.length > 0 ? (
          sdg.facts.map((fact, index) => (
            <div key={index} style={styles.card}>
              <div style={{ color: sdg.color, marginTop: "2px" }}>•</div>
              <p style={styles.cardText}>{fact}</p>
            </div>
          ))
        ) : (
          <p style={{ fontStyle: "italic", color: "#94A3B8" }}>Content coming soon...</p>
        )}

        {/* ACTIONS SECTION */}
        <h2 style={styles.sectionTitle}>
          <CheckCircle2 size={22} /> Small Actions, Big Impact
        </h2>
        {sdg.actions && sdg.actions.length > 0 ? (
          sdg.actions.map((action, index) => (
            <div key={index} style={styles.card}>
              <CheckCircle2 size={18} color={sdg.color} style={{ flexShrink: 0 }} />
              <p style={styles.cardText}>{action}</p>
            </div>
          ))
        ) : (
          <p style={{ fontStyle: "italic", color: "#94A3B8" }}>Content coming soon...</p>
        )}
      </div>
    </div>
  );
}